import { Icon20Check } from '@vkontakte/icons';
import classNames from 'clsx';
import { isNil } from 'ramda';
import React, { ReactNode, VFC } from 'react';
import { DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { HotKeyTip } from 'reactApp/ui/HotKeyTip/HotKeyTip';
import { ArrowUpSmallIcon, VerifiedIcon } from 'reactApp/ui/VKUIIcons';

import styles from './DropdownItemAction.css';

interface Props {
    mod?: string;
    asc?: boolean;
    withStatus?: boolean;
    icon?: ReactNode;
    active?: boolean;
    text: string;
    hotkey?: string;
    id?: string;
    theme?: DropdownTheme;
}

const renderStatus = ({ active, asc, theme }: { active?: boolean; asc?: boolean; theme?: DropdownTheme }) => {
    if (!active) {
        return <div className={styles.status} />;
    }

    if (isNil(asc)) {
        return theme === DropdownTheme.large ? (
            <div className={classNames(styles.status, styles.rightSideStatus)}>
                <Icon20Check />
            </div>
        ) : (
            <div className={styles.status}>
                <VerifiedIcon />
            </div>
        );
    }

    return (
        <div
            className={classNames({
                [styles.status]: true,
                [styles.status_flip]: asc,
            })}
        >
            <ArrowUpSmallIcon data-qa-id={asc ? 'sortAsc' : 'sortDesc'} />
        </div>
    );
};

export const DropdownItemAction: VFC<Props> = ({ mod, asc, icon, text, active, withStatus, hotkey, id, theme }) => {
    return (
        <div className={classNames(styles.root, { [styles[`root_${mod}`]]: Boolean(mod), [styles[`root_${id}`]]: id })}>
            {withStatus && theme !== DropdownTheme.large && renderStatus({ active, asc, theme })}
            {!!icon && <div className={styles.icon}>{icon}</div>}
            <div className={styles.text}>{text}</div>
            {withStatus && theme === DropdownTheme.large && renderStatus({ active, asc, theme })}
            {hotkey && (
                <div className={styles.hotkeyWrapper}>
                    {' '}
                    <HotKeyTip text={hotkey} />
                </div>
            )}
        </div>
    );
};
